import CheckoutCustomTaxExemptStatusReducer from "@sunSource/Store/Data/CheckoutCustomTaxExemptStatus/CheckoutCustomTaxExemptStatusReducer";
// import OnePageCheckoutCreateAccountReducer from "@sunSource/Store/Data/NewOnePageCheckout/OnePageCheckoutCreateAccountReducer";
import OnePageCheckoutStateReducers from "@sunSource/Store/Data/NewOnePageCheckout/OnePageCheckoutStateReducers";
// import OnePageCheckoutTabStateReducer from "@sunSource/Store/Data/NewOnePageCheckout/OnePageCheckoutStateReducers";
import OnePageCheckoutCustomNotesReducer from "@sunSource/Store/Data/OnePageCheckoutCustomNotes/OnePageCheckoutCustomNotesReducer";
import TabsDataReducer from "@sunSource/Store/Data/TabsData/TabsDataReducer";
import { combineReducers } from "redux";

const customReducers = {
    OnePageCheckoutCustomNotes: OnePageCheckoutCustomNotesReducer,
    CheckoutCustomTaxExemptStatus: CheckoutCustomTaxExemptStatusReducer,
    // OnePageCheckoutTabState: OnePageCheckoutTabStateReducer,
    // OnePageCheckoutCreateAccountState: OnePageCheckoutCreateAccountReducer,
    OnePageCheckoutData: OnePageCheckoutStateReducers,
    TabsActiveData: TabsDataReducer,
};

export type CustomDataReducers = typeof customReducers;

const customDataReducer = combineReducers(customReducers as any);

export default customDataReducer;
